<script>
	export let id = null;
	export let label = null;
	export let sublabel = null;
	export let value = null;
	export let maxlength = null;
	export let required = false;
	export let disabled = false;
	export let placeholder = null;
</script>

{#if label}
	<label for={id}>
		{label}

		{#if required}
			<span class="required">*</span>
		{/if}

		{#if sublabel}
			<div class="sublabel">{sublabel}</div>
		{/if}
	</label>
{/if}
<input
	{id}
	class="form-control"
	type="tel"
	{required}
	{disabled}
	{placeholder}
	{maxlength}
	bind:value
	phone
	on:change
/>
